(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-shop-template"]) return;
  try {
    

(function () {
  
const restaurantWines = document.getElementById(`restaurant-wines`);
  
const wineList = document.getElementById(`wine_list`);

if (!restaurantWines) return;

wineList.append(restaurantWines);
  
  
})();


  } catch(e) { console.error(e); }
})();
})();
